export const icons = [
  "fa-brands fa-500px",
  "fa-brands fa-accessible-icon",
  "fa-brands fa-accusoft",
  "fa-brands fa-acquisitions-incorporated",
  "fas fa-ad",
  "fas fa-address-book",
  "far fa-address-book",
  "fas fa-address-card",
  "far fa-address-card",
  "fas fa-adjust",
  "fa-brands fa-adn",
  "fa-brands fa-adobe",
  "fa-brands fa-adversal",
  "fa-brands fa-affiliatetheme",
  "fas fa-air-freshener",
  "fa-brands fa-airbnb",
  "fa-brands fa-algolia",
  "fas fa-align-center",
  "fas fa-align-justify",
  "fas fa-align-left",
  "fas fa-align-right",
  "fa-brands fa-alipay",
  "fas fa-allergies",
  "fa-brands fa-amazon",
  "fa-brands fa-amazon-pay",
  "fas fa-ambulance",
  "fas fa-american-sign-language-interpreting",
  "fa-brands fa-amilia",
  "fas fa-anchor",
  "fa-brands fa-android",
  "fa-brands fa-angellist",
  "fas fa-angle-double-down",
  "fas fa-angle-double-left",
  "fas fa-angle-double-right",
  "fas fa-angle-double-up",
  "fas fa-angle-down",
  "fas fa-angle-left",
  "fas fa-angle-right",
  "fas fa-angle-up",
  "fas fa-angry",
  "far fa-angry",
  "fa-brands fa-angrycreative",
  "fa-brands fa-angular",
  "fas fa-ankh",
  "fa-brands fa-app-store",
  "fa-brands fa-app-store-ios",
  "fa-brands fa-apper",
  "fa-brands fa-apple",
  "fas fa-apple-alt",
  "fa-brands fa-apple-pay",
  "fas fa-archive",
  "fas fa-archway",
  "fas fa-arrow-alt-circle-down",
  "far fa-arrow-alt-circle-down",
  "fas fa-arrow-alt-circle-left",
  "far fa-arrow-alt-circle-left",
  "fas fa-arrow-alt-circle-right",
  "far fa-arrow-alt-circle-right",
  "fas fa-arrow-alt-circle-up",
  "far fa-arrow-alt-circle-up",
  "fas fa-arrow-circle-down",
  "fas fa-arrow-circle-left",
  "fas fa-arrow-circle-right",
  "fas fa-arrow-circle-up",
  "fas fa-arrow-down",
  "fas fa-arrow-left",
  "fas fa-arrow-right",
  "fas fa-arrow-up",
  "fas fa-arrows-alt",
  "fas fa-arrows-alt-h",
  "fas fa-arrows-alt-v",
  "fa-brands fa-artstation",
  "fas fa-assistive-listening-systems",
  "fas fa-asterisk",
  "fa-brands fa-asymmetrik",
  "fas fa-at",
  "fas fa-atlas",
  "fa-brands fa-atlassian",
  "fas fa-atom",
  "fa-brands fa-audible",
  "fas fa-audio-description",
  "fa-brands fa-autoprefixer",
  "fa-brands fa-avianex",
  "fa-brands fa-aviato",
  "fas fa-award",
  "fa-brands fa-aws",
  "fas fa-baby",
  "fas fa-baby-carriage",
  "fas fa-backspace",
  "fas fa-backward",
  "fas fa-bacon",
  "fas fa-balance-scale",
  "fas fa-balance-scale-left",
  "fas fa-balance-scale-right",
  "fas fa-ban",
  "fas fa-band-aid",
  "fa-brands fa-bandcamp",
  "fas fa-barcode",
  "fas fa-bars",
  "fas fa-baseball-ball",
  "fas fa-basketball-ball",
  "fas fa-bath",
  "fas fa-battery-empty",
  "fas fa-battery-full",
  "fas fa-battery-half",
  "fas fa-battery-quarter",
  "fas fa-battery-three-quarters",
  "fa-brands fa-battle-net",
  "fas fa-bed",
  "fas fa-beer",
  "fa-brands fa-behance",
  "fa-brands fa-behance-square",
  "fas fa-bell",
  "far fa-bell",
  "fas fa-bell-slash",
  "far fa-bell-slash",
  "fas fa-bezier-curve",
  "fas fa-bible",
  "fas fa-bicycle",
  "fas fa-biking",
  "fa-brands fa-bimobject",
  "fas fa-binoculars",
  "fas fa-biohazard",
  "fas fa-birthday-cake",
  "fa-brands fa-bitbucket",
  "fa-brands fa-bitcoin",
  "fa-brands fa-bity",
  "fa-brands fa-black-tie",
  "fa-brands fa-blackberry",
  "fas fa-blender",
  "fas fa-blender-phone",
  "fas fa-blind",
  "fas fa-blog",
  "fa-brands fa-blogger",
  "fa-brands fa-blogger-b",
  "fa-brands fa-bluetooth",
  "fa-brands fa-bluetooth-b",
  "fas fa-bold",
  "fas fa-bolt",
  "fas fa-bomb",
  "fas fa-bone",
  "fas fa-bong",
  "fas fa-book",
  "fas fa-book-dead",
  "fas fa-book-medical",
  "fas fa-book-open",
  "fas fa-book-reader",
  "fas fa-bookmark",
  "far fa-bookmark",
  "fa-brands fa-bootstrap",
  "fas fa-border-all",
  "fas fa-border-none",
  "fas fa-border-style",
  "fas fa-bowling-ball",
  "fas fa-box",
  "fas fa-box-open",
  "fas fa-boxes",
  "fas fa-braille",
  "fas fa-brain",
  "fas fa-bread-slice",
  "fas fa-briefcase",
  "fas fa-briefcase-medical",
  "fas fa-broadcast-tower",
  "fas fa-broom",
  "fas fa-brush",
  "fa-brands fa-btc",
  "fa-brands fa-buffer",
  "fas fa-bug",
  "fas fa-building",
  "far fa-building",
  "fas fa-bullhorn",
  "fas fa-bullseye",
  "fas fa-burn",
  "fa-brands fa-buromobelexperte",
  "fas fa-bus",
  "fas fa-bus-alt",
  "fas fa-business-time",
  "fa-brands fa-buy-n-large",
  "fa-brands fa-buysellads",
  "fas fa-calculator",
  "fas fa-calendar",
  "far fa-calendar",
  "fas fa-calendar-alt",
  "far fa-calendar-alt",
  "fas fa-calendar-check",
  "far fa-calendar-check",
  "fas fa-calendar-day",
  "fas fa-calendar-minus",
  "far fa-calendar-minus",
  "fas fa-calendar-plus",
  "far fa-calendar-plus",
  "fas fa-calendar-times",
  "far fa-calendar-times",
  "fas fa-calendar-week",
  "fas fa-camera",
  "fas fa-camera-retro",
  "fas fa-campground",
  "fa-brands fa-canadian-maple-leaf",
  "fas fa-candy-cane",
  "fas fa-cannabis",
  "fas fa-capsules",
  "fas fa-car",
  "fas fa-car-alt",
  "fas fa-car-battery",
  "fas fa-car-crash",
  "fas fa-car-side",
  "fas fa-caret-down",
  "fas fa-caret-left",
  "fas fa-caret-right",
  "fas fa-caret-square-down",
  "far fa-caret-square-down",
  "fas fa-caret-square-left",
  "far fa-caret-square-left",
  "fas fa-caret-square-right",
  "far fa-caret-square-right",
  "fas fa-caret-square-up",
  "far fa-caret-square-up",
  "fas fa-caret-up",
  "fas fa-carrot",
  "fas fa-cart-arrow-down",
  "fas fa-cart-plus",
  "fas fa-cash-register",
  "fas fa-cat",
  "fa-brands fa-cc-amazon-pay",
  "fa-brands fa-cc-amex",
  "fa-brands fa-cc-apple-pay",
  "fa-brands fa-cc-diners-club",
  "fa-brands fa-cc-discover",
  "fa-brands fa-cc-jcb",
  "fa-brands fa-cc-mastercard",
  "fa-brands fa-cc-paypal",
  "fa-brands fa-cc-stripe",
  "fa-brands fa-cc-visa",
  "fa-brands fa-centercode",
  "fa-brands fa-centos",
  "fas fa-certificate",
  "fas fa-chair",
  "fas fa-chalkboard",
  "fas fa-chalkboard-teacher",
  "fas fa-charging-station",
  "fas fa-chart-area",
  "fas fa-chart-bar",
  "far fa-chart-bar",
  "fas fa-chart-line",
  "fas fa-chart-pie",
  "fas fa-check",
  "fas fa-check-circle",
  "far fa-check-circle",
  "fas fa-check-double",
  "fas fa-check-square",
  "far fa-check-square",
  "fas fa-cheese",
  "fas fa-chess",
  "fas fa-chess-bishop",
  "fas fa-chess-board",
  "fas fa-chess-king",
  "fas fa-chess-knight",
  "fas fa-chess-pawn",
  "fas fa-chess-queen",
  "fas fa-chess-rook",
  "fas fa-chevron-circle-down",
  "fas fa-chevron-circle-left",
  "fas fa-chevron-circle-right",
  "fas fa-chevron-circle-up",
  "fas fa-chevron-down",
  "fas fa-chevron-left",
  "fas fa-chevron-right",
  "fas fa-chevron-up",
  "fas fa-child",
  "fa-brands fa-chrome",
  "fa-brands fa-chromecast",
  "fas fa-church",
  "fas fa-circle",
  "far fa-circle",
  "fas fa-circle-notch",
  "fas fa-city",
  "fas fa-clinic-medical",
  "fas fa-clipboard",
  "far fa-clipboard",
  "fas fa-clipboard-check",
  "fas fa-clipboard-list",
  "fas fa-clock",
  "far fa-clock",
  "fas fa-clone",
  "far fa-clone",
  "fas fa-closed-captioning",
  "far fa-closed-captioning",
  "fas fa-cloud",
  "fas fa-cloud-download-alt",
  "fas fa-cloud-meatball",
  "fas fa-cloud-moon",
  "fas fa-cloud-moon-rain",
  "fas fa-cloud-rain",
  "fas fa-cloud-showers-heavy",
  "fas fa-cloud-sun",
  "fas fa-cloud-sun-rain",
  "fas fa-cloud-upload-alt",
  "fa-brands fa-cloudscale",
  "fa-brands fa-cloudsmith",
  "fa-brands fa-cloudversify",
  "fas fa-cocktail",
  "fas fa-code",
  "fas fa-code-branch",
  "fa-brands fa-codepen",
  "fa-brands fa-codiepie",
  "fas fa-coffee",
  "fas fa-cog",
  "fas fa-cogs",
  "fas fa-coins",
  "fas fa-columns",
  "fas fa-comment",
  "far fa-comment",
  "fas fa-comment-alt",
  "far fa-comment-alt",
  "fas fa-comment-dollar",
  "fas fa-comment-dots",
  "far fa-comment-dots",
  "fas fa-comment-medical",
  "fas fa-comment-slash",
  "fas fa-comments",
  "far fa-comments",
  "fas fa-comments-dollar",
  "fas fa-compact-disc",
  "fas fa-compass",
  "far fa-compass",
  "fas fa-compress",
  "fas fa-compress-arrows-alt",
  "fas fa-concierge-bell",
  "fa-brands fa-confluence",
  "fa-brands fa-connectdevelop",
  "fa-brands fa-contao",
  "fas fa-cookie",
  "fas fa-cookie-bite",
  "fas fa-copy",
  "far fa-copy",
  "fas fa-copyright",
  "far fa-copyright",
  "fa-brands fa-cotton-bureau",
  "fas fa-couch",
  "fa-brands fa-cpanel",
  "fa-brands fa-creative-commons",
  "fa-brands fa-creative-commons-by",
  "fa-brands fa-creative-commons-nc",
  "fa-brands fa-creative-commons-nc-eu",
  "fa-brands fa-creative-commons-nc-jp",
  "fa-brands fa-creative-commons-nd",
  "fa-brands fa-creative-commons-pd",
  "fa-brands fa-creative-commons-pd-alt",
  "fa-brands fa-creative-commons-remix",
  "fa-brands fa-creative-commons-sa",
  "fa-brands fa-creative-commons-sampling",
  "fa-brands fa-creative-commons-sampling-plus",
  "fa-brands fa-creative-commons-share",
  "fa-brands fa-creative-commons-zero",
  "fas fa-credit-card",
  "far fa-credit-card",
  "fa-brands fa-critical-role",
  "fas fa-crop",
  "fas fa-crop-alt",
  "fas fa-cross",
  "fas fa-crosshairs",
  "fas fa-crow",
  "fas fa-crown",
  "fas fa-crutch",
  "fa-brands fa-css3",
  "fa-brands fa-css3-alt",
  "fas fa-cube",
  "fas fa-cubes",
  "fas fa-cut",
  "fa-brands fa-cuttlefish",
  "fa-brands fa-d-and-d",
  "fa-brands fa-d-and-d-beyond",
  "fa-brands fa-dashcube",
  "fas fa-database",
  "fas fa-deaf",
  "fa-brands fa-delicious",
  "fas fa-democrat",
  "fa-brands fa-deploydog",
  "fa-brands fa-deskpro",
  "fas fa-desktop",
  "fa-brands fa-dev",
  "fa-brands fa-deviantart",
  "fas fa-dharmachakra",
  "fa-brands fa-dhl",
  "fas fa-diagnoses",
  "fa-brands fa-diaspora",
  "fas fa-dice",
  "fas fa-dice-d20",
  "fas fa-dice-d6",
  "fas fa-dice-five",
  "fas fa-dice-four",
  "fas fa-dice-one",
  "fas fa-dice-six",
  "fas fa-dice-three",
  "fas fa-dice-two",
  "fa-brands fa-digg",
  "fa-brands fa-digital-ocean",
  "fas fa-digital-tachograph",
  "fas fa-directions",
  "fa-brands fa-discord",
  "fa-brands fa-discourse",
  "fas fa-divide",
  "fas fa-dizzy",
  "far fa-dizzy",
  "fas fa-dna",
  "fa-brands fa-dochub",
  "fa-brands fa-docker",
  "fas fa-dog",
  "fas fa-dollar-sign",
  "fas fa-dolly",
  "fas fa-dolly-flatbed",
  "fas fa-donate",
  "fas fa-door-closed",
  "fas fa-door-open",
  "fas fa-dot-circle",
  "far fa-dot-circle",
  "fas fa-dove",
  "fas fa-download",
  "fa-brands fa-draft2digital",
  "fas fa-drafting-compass",
  "fas fa-dragon",
  "fas fa-draw-polygon",
  "fa-brands fa-dribbble",
  "fa-brands fa-dribbble-square",
  "fa-brands fa-dropbox",
  "fas fa-drum",
  "fas fa-drum-steelpan",
  "fas fa-drumstick-bite",
  "fa-brands fa-drupal",
  "fas fa-dumbbell",
  "fas fa-dumpster",
  "fas fa-dumpster-fire",
  "fas fa-dungeon",
  "fa-brands fa-dyalog",
  "fa-brands fa-earlybirds",
  "fa-brands fa-ebay",
  "fa-brands fa-edge",
  "fas fa-edit",
  "far fa-edit",
  "fas fa-egg",
  "fas fa-eject",
  "fa-brands fa-elementor",
  "fas fa-ellipsis-h",
  "fas fa-ellipsis-v",
  "fa-brands fa-ello",
  "fa-brands fa-ember",
  "fa-brands fa-empire",
  "fas fa-envelope",
  "far fa-envelope",
  "fas fa-envelope-open",
  "far fa-envelope-open",
  "fas fa-envelope-open-text",
  "fas fa-envelope-square",
  "fa-brands fa-envira",
  "fas fa-equals",
  "fas fa-eraser",
  "fa-brands fa-erlang",
  "fa-brands fa-ethereum",
  "fas fa-ethernet",
  "fa-brands fa-etsy",
  "fas fa-euro-sign",
  "fa-brands fa-evernote",
  "fas fa-exchange-alt",
  "fas fa-exclamation",
  "fas fa-exclamation-circle",
  "fas fa-exclamation-triangle",
  "fas fa-expand",
  "fas fa-expand-arrows-alt",
  "fa-brands fa-expeditedssl",
  "fas fa-external-link-alt",
  "fas fa-external-link-square-alt",
  "fas fa-eye",
  "far fa-eye",
  "fas fa-eye-dropper",
  "fas fa-eye-slash",
  "far fa-eye-slash",
  "fa-brands fa-facebook",
  "fa-brands fa-facebook-f",
  "fa-brands fa-facebook-messenger",
  "fa-brands fa-facebook-square",
  "fas fa-fan",
  "fa-brands fa-fantasy-flight-games",
  "fas fa-fast-backward",
  "fas fa-fast-forward",
  "fas fa-fax",
  "fas fa-feather",
  "fas fa-feather-alt",
  "fa-brands fa-fedex",
  "fa-brands fa-fedora",
  "fas fa-female",
  "fas fa-fighter-jet",
  "fa-brands fa-figma",
  "fas fa-file",
  "far fa-file",
  "fas fa-file-alt",
  "far fa-file-alt",
  "fas fa-file-archive",
  "far fa-file-archive",
  "fas fa-file-audio",
  "far fa-file-audio",
  "fas fa-file-code",
  "far fa-file-code",
  "fas fa-file-contract",
  "fas fa-file-csv",
  "fas fa-file-download",
  "fas fa-file-excel",
  "far fa-file-excel",
  "fas fa-file-export",
  "fas fa-file-image",
  "far fa-file-image",
  "fas fa-file-import",
  "fas fa-file-invoice",
  "fas fa-file-invoice-dollar",
  "fas fa-file-medical",
  "fas fa-file-medical-alt",
  "fas fa-file-pdf",
  "far fa-file-pdf",
  "fas fa-file-powerpoint",
  "far fa-file-powerpoint",
  "fas fa-file-prescription",
  "fas fa-file-signature",
  "fas fa-file-upload",
  "fas fa-file-video",
  "far fa-file-video",
  "fas fa-file-word",
  "far fa-file-word",
  "fas fa-fill",
  "fas fa-fill-drip",
  "fas fa-film",
  "fas fa-filter",
  "fas fa-fingerprint",
  "fas fa-fire",
  "fas fa-fire-alt",
  "fas fa-fire-extinguisher",
  "fa-brands fa-firefox",
  "fas fa-first-aid",
  "fa-brands fa-first-order",
  "fa-brands fa-first-order-alt",
  "fa-brands fa-firstdraft",
  "fas fa-fish",
  "fas fa-fist-raised",
  "fas fa-flag",
  "far fa-flag",
  "fas fa-flag-checkered",
  "fas fa-flag-usa",
  "fas fa-flask",
  "fa-brands fa-flickr",
  "fa-brands fa-flipboard",
  "fas fa-flushed",
  "far fa-flushed",
  "fa-brands fa-fly",
  "fas fa-folder",
  "far fa-folder",
  "fas fa-folder-minus",
  "fas fa-folder-open",
  "far fa-folder-open",
  "fas fa-folder-plus",
  "fas fa-font",
  "fa-brands fa-font-awesome",
  "fa-brands fa-font-awesome-alt",
  "fa-brands fa-font-awesome-flag",
  "fa-brands fa-fonticons",
  "fa-brands fa-fonticons-fi",
  "fas fa-football-ball",
  "fa-brands fa-fort-awesome",
  "fa-brands fa-fort-awesome-alt",
  "fa-brands fa-forumbee",
  "fas fa-forward",
  "fa-brands fa-foursquare",
  "fa-brands fa-free-code-camp",
  "fa-brands fa-freebsd",
  "fas fa-frog",
  "fas fa-frown",
  "far fa-frown",
  "fas fa-frown-open",
  "far fa-frown-open",
  "fa-brands fa-fulcrum",
  "fas fa-funnel-dollar",
  "fas fa-futbol",
  "far fa-futbol",
  "fa-brands fa-galactic-republic",
  "fa-brands fa-galactic-senate",
  "fas fa-gamepad",
  "fas fa-gas-pump",
  "fas fa-gavel",
  "fas fa-gem",
  "far fa-gem",
  "fas fa-genderless",
  "fa-brands fa-get-pocket",
  "fa-brands fa-gg",
  "fa-brands fa-gg-circle",
  "fas fa-ghost",
  "fas fa-gift",
  "fas fa-gifts",
  "fa-brands fa-git",
  "fa-brands fa-git-alt",
  "fa-brands fa-git-square",
  "fa-brands fa-github",
  "fa-brands fa-github-alt",
  "fa-brands fa-github-square",
  "fa-brands fa-gitkraken",
  "fa-brands fa-gitlab",
  "fa-brands fa-gitter",
  "fas fa-glass-cheers",
  "fas fa-glass-martini",
  "fas fa-glass-martini-alt",
  "fas fa-glass-whiskey",
  "fas fa-glasses",
  "fa-brands fa-glide",
  "fa-brands fa-glide-g",
  "fas fa-globe",
  "fas fa-globe-africa",
  "fas fa-globe-americas",
  "fas fa-globe-asia",
  "fas fa-globe-europe",
  "fa-brands fa-gofore",
  "fas fa-golf-ball",
  "fa-brands fa-goodreads",
  "fa-brands fa-goodreads-g",
  "fa-brands fa-google",
  "fa-brands fa-google-drive",
  "fa-brands fa-google-play",
  "fa-brands fa-google-plus",
  "fa-brands fa-google-plus-g",
  "fa-brands fa-google-plus-square",
  "fa-brands fa-google-wallet",
  "fas fa-gopuram",
  "fas fa-graduation-cap",
  "fa-brands fa-gratipay",
  "fa-brands fa-grav",
  "fas fa-greater-than",
  "fas fa-greater-than-equal",
  "fas fa-grimace",
  "far fa-grimace",
  "fas fa-grin",
  "far fa-grin",
  "fas fa-grin-alt",
  "far fa-grin-alt",
  "fas fa-grin-beam",
  "far fa-grin-beam",
  "fas fa-grin-beam-sweat",
  "far fa-grin-beam-sweat",
  "fas fa-grin-hearts",
  "far fa-grin-hearts",
  "fas fa-grin-squint",
  "far fa-grin-squint",
  "fas fa-grin-squint-tears",
  "far fa-grin-squint-tears",
  "fas fa-grin-stars",
  "far fa-grin-stars",
  "fas fa-grin-tears",
  "far fa-grin-tears",
  "fas fa-grin-tongue",
  "far fa-grin-tongue",
  "fas fa-grin-tongue-squint",
  "far fa-grin-tongue-squint",
  "fas fa-grin-tongue-wink",
  "far fa-grin-tongue-wink",
  "fas fa-grin-wink",
  "far fa-grin-wink",
  "fas fa-grip-horizontal",
  "fas fa-grip-lines",
  "fas fa-grip-lines-vertical",
  "fas fa-grip-vertical",
  "fa-brands fa-gripfire",
  "fa-brands fa-grunt",
  "fas fa-guitar",
  "fa-brands fa-gulp",
  "fas fa-h-square",
  "fa-brands fa-hacker-news",
  "fa-brands fa-hacker-news-square",
  "fa-brands fa-hackerrank",
  "fas fa-hamburger",
  "fas fa-hammer",
  "fas fa-hamsa",
  "fas fa-hand-holding",
  "fas fa-hand-holding-heart",
  "fas fa-hand-holding-usd",
  "fas fa-hand-lizard",
  "far fa-hand-lizard",
  "fas fa-hand-middle-finger",
  "fas fa-hand-paper",
  "far fa-hand-paper",
  "fas fa-hand-peace",
  "far fa-hand-peace",
  "fas fa-hand-point-down",
  "far fa-hand-point-down",
  "fas fa-hand-point-left",
  "far fa-hand-point-left",
  "fas fa-hand-point-right",
  "far fa-hand-point-right",
  "fas fa-hand-point-up",
  "far fa-hand-point-up",
  "fas fa-hand-pointer",
  "far fa-hand-pointer",
  "fas fa-hand-rock",
  "far fa-hand-rock",
  "fas fa-hand-scissors",
  "far fa-hand-scissors",
  "fas fa-hand-spock",
  "far fa-hand-spock",
  "fas fa-hands",
  "fas fa-hands-helping",
  "fas fa-handshake",
  "far fa-handshake",
  "fas fa-hanukiah",
  "fas fa-hard-hat",
  "fas fa-hashtag",
  "fas fa-hat-cowboy",
  "fas fa-hat-cowboy-side",
  "fas fa-hat-wizard",
  "fas fa-haykal",
  "fas fa-hdd",
  "far fa-hdd",
  "fas fa-heading",
  "fas fa-headphones",
  "fas fa-headphones-alt",
  "fas fa-headset",
  "fas fa-heart",
  "far fa-heart",
  "fas fa-heart-broken",
  "fas fa-heartbeat",
  "fas fa-helicopter",
  "fas fa-highlighter",
  "fas fa-hiking",
  "fas fa-hippo",
  "fa-brands fa-hips",
  "fa-brands fa-hire-a-helper",
  "fas fa-history",
  "fas fa-hockey-puck",
  "fas fa-holly-berry",
  "fas fa-home",
  "fa-brands fa-hooli",
  "fa-brands fa-hornbill",
  "fas fa-horse",
  "fas fa-horse-head",
  "fas fa-hospital",
  "far fa-hospital",
  "fas fa-hospital-alt",
  "fas fa-hospital-symbol",
  "fas fa-hot-tub",
  "fas fa-hotdog",
  "fas fa-hotel",
  "fa-brands fa-hotjar",
  "fas fa-hourglass",
  "far fa-hourglass",
  "fas fa-hourglass-end",
  "fas fa-hourglass-half",
  "fas fa-hourglass-start",
  "fas fa-house-damage",
  "fa-brands fa-houzz",
  "fas fa-hryvnia",
  "fa-brands fa-html5",
  "fa-brands fa-hubspot",
  "fas fa-i-cursor",
  "fas fa-ice-cream",
  "fas fa-icicles",
  "fas fa-icons",
  "fas fa-id-badge",
  "far fa-id-badge",
  "fas fa-id-card",
  "far fa-id-card",
  "fas fa-id-card-alt",
  "fas fa-igloo",
  "fas fa-image",
  "far fa-image",
  "fas fa-images",
  "far fa-images",
  "fa-brands fa-imdb",
  "fas fa-inbox",
  "fas fa-indent",
  "fas fa-industry",
  "fas fa-infinity",
  "fas fa-info",
  "fas fa-info-circle",
  "fa-brands fa-instagram",
  "fa-brands fa-intercom",
  "fa-brands fa-internet-explorer",
  "fa-brands fa-invision",
  "fa-brands fa-ioxhost",
  "fas fa-italic",
  "fa-brands fa-itch-io",
  "fa-brands fa-itunes",
  "fa-brands fa-itunes-note",
  "fa-brands fa-java",
  "fas fa-jedi",
  "fa-brands fa-jedi-order",
  "fa-brands fa-jenkins",
  "fa-brands fa-jira",
  "fa-brands fa-joget",
  "fas fa-joint",
  "fa-brands fa-joomla",
  "fas fa-journal-whills",
  "fa-brands fa-js",
  "fa-brands fa-js-square",
  "fa-brands fa-jsfiddle",
  "fas fa-kaaba",
  "fa-brands fa-kaggle",
  "fas fa-key",
  "fa-brands fa-keybase",
  "fas fa-keyboard",
  "far fa-keyboard",
  "fa-brands fa-keycdn",
  "fas fa-khanda",
  "fa-brands fa-kickstarter",
  "fa-brands fa-kickstarter-k",
  "fas fa-kiss",
  "far fa-kiss",
  "fas fa-kiss-beam",
  "far fa-kiss-beam",
  "fas fa-kiss-wink-heart",
  "far fa-kiss-wink-heart",
  "fas fa-kiwi-bird",
  "fa-brands fa-korvue",
  "fas fa-landmark",
  "fas fa-language",
  "fas fa-laptop",
  "fas fa-laptop-code",
  "fas fa-laptop-medical",
  "fa-brands fa-laravel",
  "fa-brands fa-lastfm",
  "fa-brands fa-lastfm-square",
  "fas fa-laugh",
  "far fa-laugh",
  "fas fa-laugh-beam",
  "far fa-laugh-beam",
  "fas fa-laugh-squint",
  "far fa-laugh-squint",
  "fas fa-laugh-wink",
  "far fa-laugh-wink",
  "fas fa-layer-group",
  "fas fa-leaf",
  "fa-brands fa-leanpub",
  "fas fa-lemon",
  "far fa-lemon",
  "fa-brands fa-less",
  "fas fa-less-than",
  "fas fa-less-than-equal",
  "fas fa-level-down-alt",
  "fas fa-level-up-alt",
  "fas fa-life-ring",
  "far fa-life-ring",
  "fas fa-lightbulb",
  "far fa-lightbulb",
  "fa-brands fa-line",
  "fas fa-link",
  "fa-brands fa-linkedin",
  "fa-brands fa-linkedin-in",
  "fa-brands fa-linode",
  "fa-brands fa-linux",
  "fas fa-lira-sign",
  "fas fa-list",
  "fas fa-list-alt",
  "far fa-list-alt",
  "fas fa-list-ol",
  "fas fa-list-ul",
  "fas fa-location-arrow",
  "fas fa-lock",
  "fas fa-lock-open",
  "fas fa-long-arrow-alt-down",
  "fas fa-long-arrow-alt-left",
  "fas fa-long-arrow-alt-right",
  "fas fa-long-arrow-alt-up",
  "fas fa-low-vision",
  "fas fa-luggage-cart",
  "fa-brands fa-lyft",
  "fa-brands fa-magento",
  "fas fa-magic",
  "fas fa-magnet",
  "fas fa-mail-bulk",
  "fa-brands fa-mailchimp",
  "fas fa-male",
  "fa-brands fa-mandalorian",
  "fas fa-map",
  "far fa-map",
  "fas fa-map-marked",
  "fas fa-map-marked-alt",
  "fas fa-map-marker",
  "fas fa-map-marker-alt",
  "fas fa-map-pin",
  "fas fa-map-signs",
  "fa-brands fa-markdown",
  "fas fa-marker",
  "fas fa-mars",
  "fas fa-mars-double",
  "fas fa-mars-stroke",
  "fas fa-mars-stroke-h",
  "fas fa-mars-stroke-v",
  "fas fa-mask",
  "fa-brands fa-mastodon",
  "fa-brands fa-maxcdn",
  "fa-brands fa-mdb",
  "fas fa-medal",
  "fa-brands fa-medapps",
  "fa-brands fa-medium",
  "fa-brands fa-medium-m",
  "fas fa-medkit",
  "fa-brands fa-medrt",
  "fa-brands fa-meetup",
  "fa-brands fa-megaport",
  "fas fa-meh",
  "far fa-meh",
  "fas fa-meh-blank",
  "far fa-meh-blank",
  "fas fa-meh-rolling-eyes",
  "far fa-meh-rolling-eyes",
  "fas fa-memory",
  "fa-brands fa-mendeley",
  "fas fa-menorah",
  "fas fa-mercury",
  "fas fa-meteor",
  "fas fa-microchip",
  "fas fa-microphone",
  "fas fa-microphone-alt",
  "fas fa-microphone-alt-slash",
  "fas fa-microphone-slash",
  "fas fa-microscope",
  "fa-brands fa-microsoft",
  "fas fa-minus",
  "fas fa-minus-circle",
  "fas fa-minus-square",
  "far fa-minus-square",
  "fas fa-mitten",
  "fa-brands fa-mix",
  "fa-brands fa-mixcloud",
  "fa-brands fa-mizuni",
  "fas fa-mobile",
  "fas fa-mobile-alt",
  "fa-brands fa-modx",
  "fa-brands fa-monero",
  "fas fa-money-bill",
  "fas fa-money-bill-alt",
  "far fa-money-bill-alt",
  "fas fa-money-bill-wave",
  "fas fa-money-bill-wave-alt",
  "fas fa-money-check",
  "fas fa-money-check-alt",
  "fas fa-monument",
  "fas fa-moon",
  "far fa-moon",
  "fas fa-mortar-pestle",
  "fas fa-mosque",
  "fas fa-motorcycle",
  "fas fa-mountain",
  "fas fa-mouse",
  "fas fa-mouse-pointer",
  "fas fa-mug-hot",
  "fas fa-music",
  "fa-brands fa-napster",
  "fa-brands fa-neos",
  "fas fa-network-wired",
  "fas fa-neuter",
  "fas fa-newspaper",
  "far fa-newspaper",
  "fa-brands fa-nimblr",
  "fa-brands fa-node",
  "fa-brands fa-node-js",
  "fas fa-not-equal",
  "fas fa-notes-medical",
  "fa-brands fa-npm",
  "fa-brands fa-ns8",
  "fa-brands fa-nutritionix",
  "fas fa-object-group",
  "far fa-object-group",
  "fas fa-object-ungroup",
  "far fa-object-ungroup",
  "fa-brands fa-odnoklassniki",
  "fa-brands fa-odnoklassniki-square",
  "fas fa-oil-can",
  "fa-brands fa-old-republic",
  "fas fa-om",
  "fa-brands fa-opencart",
  "fa-brands fa-openid",
  "fa-brands fa-opera",
  "fa-brands fa-optin-monster",
  "fa-brands fa-orcid",
  "fa-brands fa-osi",
  "fas fa-otter",
  "fas fa-outdent",
  "fa-brands fa-page4",
  "fa-brands fa-pagelines",
  "fas fa-pager",
  "fas fa-paint-brush",
  "fas fa-paint-roller",
  "fas fa-palette",
  "fa-brands fa-palfed",
  "fas fa-pallet",
  "fas fa-paper-plane",
  "far fa-paper-plane",
  "fas fa-paperclip",
  "fas fa-parachute-box",
  "fas fa-paragraph",
  "fas fa-parking",
  "fas fa-passport",
  "fas fa-pastafarianism",
  "fas fa-paste",
  "fa-brands fa-patreon",
  "fas fa-pause",
  "fas fa-pause-circle",
  "far fa-pause-circle",
  "fas fa-paw",
  "fa-brands fa-paypal",
  "fas fa-peace",
  "fas fa-pen",
  "fas fa-pen-alt",
  "fas fa-pen-fancy",
  "fas fa-pen-nib",
  "fas fa-pen-square",
  "fas fa-pencil-alt",
  "fas fa-pencil-ruler",
  "fa-brands fa-penny-arcade",
  "fas fa-people-carry",
  "fas fa-pepper-hot",
  "fas fa-percent",
  "fas fa-percentage",
  "fa-brands fa-periscope",
  "fas fa-person-booth",
  "fa-brands fa-phabricator",
  "fa-brands fa-phoenix-framework",
  "fa-brands fa-phoenix-squadron",
  "fas fa-phone",
  "fas fa-phone-alt",
  "fas fa-phone-slash",
  "fas fa-phone-square",
  "fas fa-phone-square-alt",
  "fas fa-phone-volume",
  "fas fa-photo-video",
  "fa-brands fa-php",
  "fa-brands fa-pied-piper",
  "fa-brands fa-pied-piper-alt",
  "fa-brands fa-pied-piper-hat",
  "fa-brands fa-pied-piper-pp",
  "fas fa-piggy-bank",
  "fas fa-pills",
  "fa-brands fa-pinterest",
  "fa-brands fa-pinterest-p",
  "fa-brands fa-pinterest-square",
  "fas fa-pizza-slice",
  "fas fa-place-of-worship",
  "fas fa-plane",
  "fas fa-plane-arrival",
  "fas fa-plane-departure",
  "fas fa-play",
  "fas fa-play-circle",
  "far fa-play-circle",
  "fa-brands fa-playstation",
  "fas fa-plug",
  "fas fa-plus",
  "fas fa-plus-circle",
  "fas fa-plus-square",
  "far fa-plus-square",
  "fas fa-podcast",
  "fas fa-poll",
  "fas fa-poll-h",
  "fas fa-poo",
  "fas fa-poo-storm",
  "fas fa-poop",
  "fas fa-portrait",
  "fas fa-pound-sign",
  "fas fa-power-off",
  "fas fa-pray",
  "fas fa-praying-hands",
  "fas fa-prescription",
  "fas fa-prescription-bottle",
  "fas fa-prescription-bottle-alt",
  "fas fa-print",
  "fas fa-procedures",
  "fa-brands fa-product-hunt",
  "fas fa-project-diagram",
  "fa-brands fa-pushed",
  "fas fa-puzzle-piece",
  "fa-brands fa-python",
  "fa-brands fa-qq",
  "fas fa-qrcode",
  "fas fa-question",
  "fas fa-question-circle",
  "far fa-question-circle",
  "fas fa-quidditch",
  "fa-brands fa-quinscape",
  "fa-brands fa-quora",
  "fas fa-quote-left",
  "fas fa-quote-right",
  "fas fa-quran",
  "fa-brands fa-r-project",
  "fas fa-radiation",
  "fas fa-radiation-alt",
  "fas fa-rainbow",
  "fas fa-random",
  "fa-brands fa-raspberry-pi",
  "fa-brands fa-ravelry",
  "fa-brands fa-react",
  "fa-brands fa-reacteurope",
  "fa-brands fa-readme",
  "fa-brands fa-rebel",
  "fas fa-receipt",
  "fas fa-record-vinyl",
  "fas fa-recycle",
  "fa-brands fa-red-river",
  "fa-brands fa-reddit",
  "fa-brands fa-reddit-alien",
  "fa-brands fa-reddit-square",
  "fa-brands fa-redhat",
  "fas fa-redo",
  "fas fa-redo-alt",
  "fas fa-registered",
  "far fa-registered",
  "fas fa-remove-format",
  "fa-brands fa-renren",
  "fas fa-reply",
  "fas fa-reply-all",
  "fa-brands fa-replyd",
  "fas fa-republican",
  "fa-brands fa-researchgate",
  "fa-brands fa-resolving",
  "fas fa-restroom",
  "fas fa-retweet",
  "fa-brands fa-rev",
  "fas fa-ribbon",
  "fas fa-ring",
  "fas fa-road",
  "fas fa-robot",
  "fas fa-rocket",
  "fa-brands fa-rocketchat",
  "fa-brands fa-rockrms",
  "fas fa-route",
  "fas fa-rss",
  "fas fa-rss-square",
  "fas fa-ruble-sign",
  "fas fa-ruler",
  "fas fa-ruler-combined",
  "fas fa-ruler-horizontal",
  "fas fa-ruler-vertical",
  "fas fa-running",
  "fas fa-rupee-sign",
  "fas fa-sad-cry",
  "far fa-sad-cry",
  "fas fa-sad-tear",
  "far fa-sad-tear",
  "fa-brands fa-safari",
  "fa-brands fa-salesforce",
  "fa-brands fa-sass",
  "fas fa-satellite",
  "fas fa-satellite-dish",
  "fas fa-save",
  "far fa-save",
  "fa-brands fa-schlix",
  "fas fa-school",
  "fas fa-screwdriver",
  "fa-brands fa-scribd",
  "fas fa-scroll",
  "fas fa-sd-card",
  "fas fa-search",
  "fas fa-search-dollar",
  "fas fa-search-location",
  "fas fa-search-minus",
  "fas fa-search-plus",
  "fa-brands fa-searchengin",
  "fas fa-seedling",
  "fa-brands fa-sellcast",
  "fa-brands fa-sellsy",
  "fas fa-server",
  "fa-brands fa-servicestack",
  "fas fa-shapes",
  "fas fa-share",
  "fas fa-share-alt",
  "fas fa-share-alt-square",
  "fas fa-share-square",
  "far fa-share-square",
  "fas fa-shekel-sign",
  "fas fa-shield-alt",
  "fas fa-ship",
  "fas fa-shipping-fast",
  "fa-brands fa-shirtsinbulk",
  "fas fa-shoe-prints",
  "fas fa-shopping-bag",
  "fas fa-shopping-basket",
  "fas fa-shopping-cart",
  "fa-brands fa-shopware",
  "fas fa-shower",
  "fas fa-shuttle-van",
  "fas fa-sign",
  "fas fa-sign-in-alt",
  "fas fa-sign-language",
  "fas fa-sign-out-alt",
  "fas fa-signal",
  "fas fa-signature",
  "fas fa-sim-card",
  "fa-brands fa-simplybuilt",
  "fa-brands fa-sistrix",
  "fas fa-sitemap",
  "fa-brands fa-sith",
  "fas fa-skating",
  "fa-brands fa-sketch",
  "fas fa-skiing",
  "fas fa-skiing-nordic",
  "fas fa-skull",
  "fas fa-skull-crossbones",
  "fa-brands fa-skyatlas",
  "fa-brands fa-skype",
  "fa-brands fa-slack",
  "fa-brands fa-slack-hash",
  "fas fa-slash",
  "fas fa-sleigh",
  "fas fa-sliders-h",
  "fa-brands fa-slideshare",
  "fas fa-smile",
  "far fa-smile",
  "fas fa-smile-beam",
  "far fa-smile-beam",
  "fas fa-smile-wink",
  "far fa-smile-wink",
  "fas fa-smog",
  "fas fa-smoking",
  "fas fa-smoking-ban",
  "fas fa-sms",
  "fa-brands fa-snapchat",
  "fa-brands fa-snapchat-ghost",
  "fa-brands fa-snapchat-square",
  "fas fa-snowboarding",
  "fas fa-snowflake",
  "far fa-snowflake",
  "fas fa-snowman",
  "fas fa-snowplow",
  "fas fa-socks",
  "fas fa-solar-panel",
  "fas fa-sort",
  "fas fa-sort-alpha-down",
  "fas fa-sort-alpha-down-alt",
  "fas fa-sort-alpha-up",
  "fas fa-sort-alpha-up-alt",
  "fas fa-sort-amount-down",
  "fas fa-sort-amount-down-alt",
  "fas fa-sort-amount-up",
  "fas fa-sort-amount-up-alt",
  "fas fa-sort-down",
  "fas fa-sort-numeric-down",
  "fas fa-sort-numeric-down-alt",
  "fas fa-sort-numeric-up",
  "fas fa-sort-numeric-up-alt",
  "fas fa-sort-up",
  "fa-brands fa-soundcloud",
  "fa-brands fa-sourcetree",
  "fas fa-spa",
  "fas fa-space-shuttle",
  "fa-brands fa-speakap",
  "fa-brands fa-speaker-deck",
  "fas fa-spell-check",
  "fas fa-spider",
  "fas fa-spinner",
  "fas fa-splotch",
  "fa-brands fa-spotify",
  "fas fa-spray-can",
  "fas fa-square",
  "far fa-square",
  "fas fa-square-full",
  "fas fa-square-root-alt",
  "fa-brands fa-squarespace",
  "fa-brands fa-stack-exchange",
  "fa-brands fa-stack-overflow",
  "fa-brands fa-stackpath",
  "fas fa-stamp",
  "fas fa-star",
  "far fa-star",
  "fas fa-star-and-crescent",
  "fas fa-star-half",
  "far fa-star-half",
  "fas fa-star-half-alt",
  "fas fa-star-of-david",
  "fas fa-star-of-life",
  "fa-brands fa-staylinked",
  "fa-brands fa-steam",
  "fa-brands fa-steam-square",
  "fa-brands fa-steam-symbol",
  "fas fa-step-backward",
  "fas fa-step-forward",
  "fas fa-stethoscope",
  "fa-brands fa-sticker-mule",
  "fas fa-sticky-note",
  "far fa-sticky-note",
  "fas fa-stop",
  "fas fa-stop-circle",
  "far fa-stop-circle",
  "fas fa-stopwatch",
  "fas fa-store",
  "fas fa-store-alt",
  "fa-brands fa-strava",
  "fas fa-stream",
  "fas fa-street-view",
  "fas fa-strikethrough",
  "fa-brands fa-stripe",
  "fa-brands fa-stripe-s",
  "fas fa-stroopwafel",
  "fa-brands fa-studiovinari",
  "fa-brands fa-stumbleupon",
  "fa-brands fa-stumbleupon-circle",
  "fas fa-subscript",
  "fas fa-subway",
  "fas fa-suitcase",
  "fas fa-suitcase-rolling",
  "fas fa-sun",
  "far fa-sun",
  "fa-brands fa-superpowers",
  "fas fa-superscript",
  "fa-brands fa-supple",
  "fas fa-surprise",
  "far fa-surprise",
  "fa-brands fa-suse",
  "fas fa-swatchbook",
  "fa-brands fa-swift",
  "fas fa-swimmer",
  "fas fa-swimming-pool",
  "fa-brands fa-symfony",
  "fas fa-synagogue",
  "fas fa-sync",
  "fas fa-sync-alt",
  "fas fa-syringe",
  "fas fa-table",
  "fas fa-table-tennis",
  "fas fa-tablet",
  "fas fa-tablet-alt",
  "fas fa-tablets",
  "fas fa-tachometer-alt",
  "fas fa-tag",
  "fas fa-tags",
  "fas fa-tape",
  "fas fa-tasks",
  "fas fa-taxi",
  "fa-brands fa-teamspeak",
  "fas fa-teeth",
  "fas fa-teeth-open",
  "fa-brands fa-telegram",
  "fa-brands fa-telegram-plane",
  "fas fa-temperature-high",
  "fas fa-temperature-low",
  "fa-brands fa-tencent-weibo",
  "fas fa-tenge",
  "fas fa-terminal",
  "fas fa-text-height",
  "fas fa-text-width",
  "fas fa-th",
  "fas fa-th-large",
  "fas fa-th-list",
  "fa-brands fa-the-red-yeti",
  "fas fa-theater-masks",
  "fa-brands fa-themeco",
  "fa-brands fa-themeisle",
  "fas fa-thermometer",
  "fas fa-thermometer-empty",
  "fas fa-thermometer-full",
  "fas fa-thermometer-half",
  "fas fa-thermometer-quarter",
  "fas fa-thermometer-three-quarters",
  "fa-brands fa-think-peaks",
  "fas fa-thumbs-down",
  "far fa-thumbs-down",
  "fas fa-thumbs-up",
  "far fa-thumbs-up",
  "fas fa-thumbtack",
  "fas fa-ticket-alt",
  "fas fa-times",
  "fas fa-times-circle",
  "far fa-times-circle",
  "fas fa-tint",
  "fas fa-tint-slash",
  "fas fa-tired",
  "far fa-tired",
  "fas fa-toggle-off",
  "fas fa-toggle-on",
  "fas fa-toilet",
  "fas fa-toilet-paper",
  "fas fa-toolbox",
  "fas fa-tools",
  "fas fa-tooth",
  "fas fa-torah",
  "fas fa-torii-gate",
  "fas fa-tractor",
  "fa-brands fa-trade-federation",
  "fas fa-trademark",
  "fas fa-traffic-light",
  "fas fa-train",
  "fas fa-tram",
  "fas fa-transgender",
  "fas fa-transgender-alt",
  "fas fa-trash",
  "fas fa-trash-alt",
  "far fa-trash-alt",
  "fas fa-trash-restore",
  "fas fa-trash-restore-alt",
  "fas fa-tree",
  "fa-brands fa-trello",
  "fa-brands fa-tripadvisor",
  "fas fa-trophy",
  "fas fa-truck",
  "fas fa-truck-loading",
  "fas fa-truck-monster",
  "fas fa-truck-moving",
  "fas fa-truck-pickup",
  "fas fa-tshirt",
  "fas fa-tty",
  "fa-brands fa-tumblr",
  "fa-brands fa-tumblr-square",
  "fas fa-tv",
  "fa-brands fa-twitch",
  "fa-brands fa-twitter",
  "fa-brands fa-twitter-square",
  "fa-brands fa-typo3",
  "fa-brands fa-uber",
  "fa-brands fa-ubuntu",
  "fa-brands fa-uikit",
  "fa-brands fa-umbraco",
  "fas fa-umbrella",
  "fas fa-umbrella-beach",
  "fas fa-underline",
  "fas fa-undo",
  "fas fa-undo-alt",
  "fa-brands fa-uniregistry",
  "fas fa-universal-access",
  "fas fa-university",
  "fas fa-unlink",
  "fas fa-unlock",
  "fas fa-unlock-alt",
  "fa-brands fa-untappd",
  "fas fa-upload",
  "fa-brands fa-ups",
  "fa-brands fa-usb",
  "fas fa-user",
  "far fa-user",
  "fas fa-user-alt",
  "fas fa-user-alt-slash",
  "fas fa-user-astronaut",
  "fas fa-user-check",
  "fas fa-user-circle",
  "far fa-user-circle",
  "fas fa-user-clock",
  "fas fa-user-cog",
  "fas fa-user-edit",
  "fas fa-user-friends",
  "fas fa-user-graduate",
  "fas fa-user-injured",
  "fas fa-user-lock",
  "fas fa-user-md",
  "fas fa-user-minus",
  "fas fa-user-ninja",
  "fas fa-user-nurse",
  "fas fa-user-plus",
  "fas fa-user-secret",
  "fas fa-user-shield",
  "fas fa-user-slash",
  "fas fa-user-tag",
  "fas fa-user-tie",
  "fas fa-user-times",
  "fas fa-users",
  "fas fa-users-cog",
  "fa-brands fa-usps",
  "fa-brands fa-ussunnah",
  "fas fa-utensil-spoon",
  "fas fa-utensils",
  "fa-brands fa-vaadin",
  "fas fa-vector-square",
  "fas fa-venus",
  "fas fa-venus-double",
  "fas fa-venus-mars",
  "fa-brands fa-viacoin",
  "fa-brands fa-viadeo",
  "fa-brands fa-viadeo-square",
  "fas fa-vial",
  "fas fa-vials",
  "fa-brands fa-viber",
  "fas fa-video",
  "fas fa-video-slash",
  "fas fa-vihara",
  "fa-brands fa-vimeo",
  "fa-brands fa-vimeo-square",
  "fa-brands fa-vimeo-v",
  "fa-brands fa-vine",
  "fa-brands fa-vk",
  "fa-brands fa-vnv",
  "fas fa-voicemail",
  "fas fa-volleyball-ball",
  "fas fa-volume-down",
  "fas fa-volume-mute",
  "fas fa-volume-off",
  "fas fa-volume-up",
  "fas fa-vote-yea",
  "fas fa-vr-cardboard",
  "fa-brands fa-vuejs",
  "fas fa-walking",
  "fas fa-wallet",
  "fas fa-warehouse",
  "fas fa-water",
  "fas fa-wave-square",
  "fa-brands fa-waze",
  "fa-brands fa-weebly",
  "fa-brands fa-weibo",
  "fas fa-weight",
  "fas fa-weight-hanging",
  "fa-brands fa-weixin",
  "fa-brands fa-whatsapp",
  "fa-brands fa-whatsapp-square",
  "fas fa-wheelchair",
  "fa-brands fa-whmcs",
  "fas fa-wifi",
  "fa-brands fa-wikipedia-w",
  "fas fa-wind",
  "fas fa-window-close",
  "far fa-window-close",
  "fas fa-window-maximize",
  "far fa-window-maximize",
  "fas fa-window-minimize",
  "far fa-window-minimize",
  "fas fa-window-restore",
  "far fa-window-restore",
  "fa-brands fa-windows",
  "fas fa-wine-bottle",
  "fas fa-wine-glass",
  "fas fa-wine-glass-alt",
  "fa-brands fa-wix",
  "fa-brands fa-wizards-of-the-coast",
  "fa-brands fa-wolf-pack-battalion",
  "fas fa-won-sign",
  "fa-brands fa-wordpress",
  "fa-brands fa-wordpress-simple",
  "fa-brands fa-wpbeginner",
  "fa-brands fa-wpexplorer",
  "fa-brands fa-wpforms",
  "fa-brands fa-wpressr",
  "fas fa-wrench",
  "fas fa-x-ray",
  "fa-brands fa-xbox",
  "fa-brands fa-xing",
  "fa-brands fa-xing-square",
  "fa-brands fa-y-combinator",
  "fa-brands fa-yahoo",
  "fa-brands fa-yammer",
  "fa-brands fa-yandex",
  "fa-brands fa-yandex-international",
  "fa-brands fa-yarn",
  "fa-brands fa-yelp",
  "fas fa-yen-sign",
  "fas fa-yin-yang",
  "fa-brands fa-yoast",
  "fa-brands fa-youtube",
  "fa-brands fa-youtube-square",
  "fa-brands fa-zhihu",
];
